import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mensaje-importante',
    templateUrl: './mensaje-importante.component.html',
    styleUrls: ['./mensaje-importante.component.less']
})
export class MensajeImportanteComponent implements OnInit {
    /** Muestra u oculta el mensaje en forma global en frontend */
    mostrarGlobalmente = true;

    constructor() { }

    ngOnInit(): void {
    }

}
